{
  "TODO": "FAIRE:",
  "account": "Compte",
  "acreInches": "acres-pouces",
  "acres": "hectares",
  "action": "Action",
  "action_one": "Action",
  "action_other": "Actes",
  "actions": "Actes",
  "active": "Actif",
  "alert": "Alerte",
  "appbarLinks": {
    "deviceConnections": "Relations",
    "devices": "Appareils",
    "fields": "Champs",
    "flowAnalytics": {
      "long": "Analyse de flux",
      "short": "Analytique"
    },
    "home": "Maison",
    "schedules": "Horaires",
    "settings": "Paramètres"
  },
  "archived": "Archivé",
  "asOfRelativeTime": "à jour {{val, relativetime}}",
  "back": "Dos",
  "cancel": "Annuler",
  "changeBtn": "Changement",
  "changeFarmAccount": "Changer de compte de ferme",
  "changesSaved": "Modifications enregistrées.",
  "charging": "Chargement",
  "checkingForUpdates": "Vérification des nouvelles mises à jour...",
  "clickToEnlarge": "Cliquez pour agrandir",
  "close": "fermer",
  "codaDeviceAlias": "Alias de l'appareil",
  "code": "Code",
  "codeSent": "Code envoyé",
  "companyName": "Siège social de la ferme",
  "confirm": "Confirmer",
  "confirmChanges": "Confirmer les modifications",
  "confirmationRequired": "Confirmation requise",
  "connections": "Relations",
  "contactUs": "Contactez-nous",
  "continue": "Continuer",
  "copiedToClipboard": "Copié dans le presse-papiers.",
  "copy": "Copie",
  "copyEmailAddress": "Copier l'e-mail",
  "dataNotAvailable": "Données non disponibles",
  "datepickersMaxDateTitle": "Fin",
  "datepickersMinDateTitle": "Commencer",
  "datepickersTitle": "Plage de dates",
  "datetimeWithVal": "{{val, datetime}}",
  "datetimeWithValAndTimezone": "{{val, datetime}} ({{timezone}})",
  "degrees": "degrés",
  "degreesWithVal": "{{val}}°",
  "delete": "Supprimer",
  "devOnly": "Réservé aux développeurs",
  "deviceId": "IDENTIFIANT",
  "deviceInstallationType": "Type d'installation",
  "deviceInstallationTypes": {
    "center_pivot": "Pivot central",
    "linear_move": "Mouvement linéaire",
    "linear_move_controller": "Contrôleur de mouvement linéaire",
    "linear_move_monitor": "Moniteur de mouvement linéaire",
    "prototype": "Prototype",
    "pump": "Pompe",
    "pump_off_only": "Pompe (arrêt uniquement)",
    "pump_on_off": "Pompe (marche/arrêt)",
    "pump_vfd": "Pompe (VFD)",
    "reel": "Bobine",
    "reel_with_booster_off_only": "Bobine avec booster (Off-Only)",
    "traveller_soft": "Voyageur (tuyau souple)",
    "unconfigured": "Non configuré",
    "valve": "Soupape"
  },
  "deviceLabelWithDeviceName": "Appareil : {{deviceName}}",
  "deviceName": "Nom de l'appareil",
  "deviceNameWithDeviceInstallationType": "{{deviceName}} ({{deviceInstallationType}})",
  "deviceProfile": "Profil de l'appareil",
  "device_one": "Appareil",
  "device_other": "Appareils",
  "devices": "Appareils",
  "disabled": "désactivé",
  "discharging": "Déchargement",
  "dismiss": "rejeter",
  "doNotShowThisAgain": "Ne plus afficher ceci",
  "done": "Fait",
  "dragSlider": "Glisser le curseur",
  "dueEast": "Plein Est",
  "dueNorth": "Plein Nord",
  "dueSouth": "Plein Sud",
  "dueWest": "Vers l'ouest",
  "edit": "modifier",
  "emailUs": "Envoyez-nous un e-mail",
  "enabled": "activé",
  "end": "Fin",
  "event_one": "Événement",
  "event_other": "Événements",
  "example": "exemple",
  "exit": "Sortie",
  "experimentalFeatureTitle": "Fonctionnalité expérimentale",
  "experimentalFeatureWarning": "Cette fonctionnalité est expérimentale et peut ne pas être entièrement prise en charge.",
  "expiresInRelativeTime": "Expire dans {{value, relativetime}}",
  "false": "FAUX",
  "farm": "ferme",
  "farmLocation": "Localisation de la ferme",
  "farmScreenTitle": "Ferme",
  "farmUserPermissionsTitle": "Autorisations des utilisateurs de la ferme",
  "field": "Champ",
  "fieldWithCount_one": "champ",
  "field_many": "Champs",
  "fields": "Champs",
  "fieldsWithCount_other": "champs",
  "filter": "Filtre",
  "firmwareVersion": "Version du micrologiciel",
  "flipSwath": "Retourner",
  "forbidden": "Interdit",
  "gettingDeviceActivity": "Récupération de l'activité de l'appareil...",
  "gettingFarm": "Obtenir des données agricoles...",
  "gettingUser": "Récupération des données utilisateur...",
  "good": "Bien",
  "goToAnalyticsSite": "Portail d'analyse",
  "help": "Aide",
  "hint": "Indice",
  "home": "Maison",
  "horizontal": "horizontal",
  "id": "IDENTIFIANT",
  "lastCheckInWithFallback": "Dernier enregistrement : il y a plus de 24 heures",
  "lastCheckInWithVal": "Dernier enregistrement : {{val, relativetime}}",
  "loading": "Chargement",
  "loadingEvents": "Chargement des événements...",
  "manage": "Gérer",
  "menu": "Menu",
  "moderate": "Modéré",
  "more": "Plus",
  "new": "nouveau",
  "newRule": "Nouvelle règle",
  "newer": "plus récent",
  "next": "Suivant",
  "no": "Non",
  "noScheduledActions": "Aucune action prévue",
  "none": "Aucun",
  "notApplicable": "N / A",
  "notCharging": "Ne charge pas",
  "notFound": "Non trouvé",
  "notNow": "Pas maintenant",
  "note": "Note",
  "noteWithColon": "Note:",
  "notificationsEnabled": "Notifications activées",
  "older": "Plus vieux",
  "ongoing": "En cours",
  "oops": "Oups",
  "or": "Ou",
  "otpFieldLabel": "Entrer le code",
  "otpFieldPlaceholder": "XXXXXX",
  "pages": "Pages",
  "percentSign": "%",
  "percentWithVal": "{{val}}%",
  "poor": "Pauvre",
  "preparingDemo": "Préparation de l'environnement de démonstration...",
  "previous": "Précédent",
  "readonly": "lecture seule",
  "reelRun": "Course de bobine",
  "reelRun_one": "Course de bobine",
  "reelRun_other": "Bobines de tournage",
  "relativeTimeWithVal": "{{val, relativetime}}",
  "reportAProblem": "Signaler un problème",
  "requestSentToDevice": "Demande envoyée à l'appareil...",
  "resendCode": "Renvoyer le code",
  "result": "Résultat",
  "reviewAndSubmit": "Réviser et soumettre",
  "save": "sauvegarder",
  "select": "Sélectionner",
  "selected": "choisi",
  "self": "Soi",
  "sensorNameWithLabel": "Capteur {{sensorName}}",
  "sensorWithSensorName": "Capteur {{sensorName}}",
  "sensor_many": "capteurs",
  "sensor_one": "capteur",
  "settings": "Paramètres",
  "showLess": "Afficher moins",
  "showMore": "Afficher plus",
  "signOut": "Se déconnecter",
  "skipForNow": "Passer pour l'instant",
  "offlineErrorMessage": "Vous êtes hors ligne. Vérifiez votre connexion et réessayez.",
  "offlineIndicator": "Hors ligne",
  "permissionDeniedErrorMessage": "Vous n'avez pas la permission de faire cela.",
  "somethingWentWrong": "Quelque chose s'est mal passé.",
  "sort": "trier",
  "sourceDevice": "Appareil source",
  "start": "Commencer",
  "startOver": "Recommencer",
  "submit": "Soumettre",
  "success": "Succès",
  "support": "Soutien",
  "targetDevice": "Appareil cible",
  "time": "Temps",
  "true": "Vrai",
  "undo": "défaire",
  "unknown": "Inconnu",
  "valWithColon": "{{val}}:",
  "verifiedFalse": "Non vérifié",
  "verifiedTrue": "Vérifié",
  "warning": "Avertissement",
  "welcome": "Accueillir",
  "whyDoWeCollectThis": "Pourquoi collectons-nous ces informations ?",
  "yes": "Oui"
}
